import React from 'react'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSoundcloud, faSpotify, faYoutube, faInstagram, faImdb } from '@fortawesome/free-brands-svg-icons'

class Footer extends React.Component {

    render() {
        const FooterMain = styled.div`
            background-color: #111;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
        `

        const SocialIcons = styled.div`
            .social_icon {
                font-size: 15px;
                color: #555;
                margin: 0 5px;
                cursor: pointer;
                transition: .5s;
                &:hover {
                    color: #04e5e5;
                }
                @media (max-width: 500px) {
                    font-size: 32px;
                    margin: 8px;
                }
            }
        `
        return (
            <FooterMain>
                <SocialIcons>
                    <FontAwesomeIcon icon={faSpotify} className="social_icon" onClick={() => window.open('https://open.spotify.com/artist/3CzoBGsEukKWTwHhCQWA1x?si=CEByu1mwSZK-2rQI40QBtA')} />
                    <FontAwesomeIcon icon={faYoutube} className="social_icon" onClick={() => window.open('https://www.youtube.com/user/srikantk90')} />
                    <FontAwesomeIcon icon={faSoundcloud} className="social_icon" onClick={() => window.open('https://soundcloud.com/srikantk')} />
                    <FontAwesomeIcon icon={faInstagram} className="social_icon" onClick={() => window.open('https://www.instagram.com/srikant_krishna/')} />
                    <FontAwesomeIcon icon={faImdb} className="social_icon" onClick={() => window.open('https://www.imdb.com/name/nm9798541/')} />
                </SocialIcons>
            </FooterMain>
        )
    }
}
export default Footer